import { render, staticRenderFns } from "./ProduitQualiformaImmo.vue?vue&type=template&id=0bc0bbc0&"
import script from "./ProduitQualiformaImmo.vue?vue&type=script&lang=js&"
export * from "./ProduitQualiformaImmo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports